import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { errorMessage } from '../../constants/errorMessage'
import Footer from './Footer'
import MiniHeader from './MiniHeader'
import qrimg from '../../assets/img/ic_profile_scan.png'
import URL from '../../constants/urls'
import { useNavigate } from 'react-router-dom'
function NotFound(props) {

    const { isFetchingPartner } = props

    //Get the partner
    const user = window.location.toString().split('/')[3]
    const navigate = useNavigate()

    

    const handleQrScan = () => {
        if(user){
            navigate(`/${user}/${URL?.FACILITY_QR}`)
        }else{
            navigate(`/${URL?.FACILITY_QR}`)
        }
        
    }
    return (
        isFetchingPartner ? null : <div className='main'>
            <MiniHeader isDisplayBack={true} title={'NOT FOUND'}/>
            <div className='d-flex justify-content-center mt-5'>
                <div className='text-center'>
                    <h4 className='m-2'>Click and Scan QR to start Parking</h4>
                    <img src={qrimg} className='img-20 mb-5' onClick={() => handleQrScan()}/>
                    <h1 className='text-center text-danger mt-5'>
                        404<br/>{errorMessage?.notFound}<br/>
                    </h1>
                </div>
            </div>
            <Footer/>
        </div>
    )
}

NotFound.propTypes = {
    dispatch: PropTypes.func,
    isFetchingPartner: PropTypes.bool,
}

NotFound.defaulProps = {
    dispatch: noop,
    isFetchingPartner: true,
}

function mapStateToProps({ userDetailsReducer }) {
    return {
        isFetchingPartner: userDetailsReducer?.isFetching
    }
}
export default connect(mapStateToProps)(NotFound)